import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const dateRangeValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const start = group.get('periodStartDate')?.value;
  const end = group.get('periodEndDate')?.value;

  if (!start || !end) { return null; }

  return new Date(start) > new Date(end)
    ? { invalidDateRange: true }
    : null;
};

export const timeRangeValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const startTime = group.get('periodStartTime')?.value;
  const endTime = group.get('periodEndTime')?.value;

  const [startHour, startMin] = startTime.split(':').map(Number);
  const [endHour, endMin] = endTime.split(':').map(Number);

  if (endHour < startHour || (endHour === startHour && endMin <= startMin)) {
    return { invalidTimeRange: true };
  }

  return null;
};
